import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasketViewComponent } from './components/basket-view/basket-view.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralModule } from '../general/general.module';
import { OrderService } from './services/order.service';
import { environment } from '../../../environments/environment';
import { OrderInMemoryService } from './services/order-in-memory.service';
import { OrderOdooService } from './services/order-odoo.service';
import { OrderStateService } from './services/order-state.service';
import { ProductsStateService } from './services/products-state.service';
import { ProductsService } from './services/products.service';
import { ProductsOdooService } from './services/products-odoo.service';
import { ProductsInMemoryService } from './services/products-in-memory.service';
import { FormsModule } from '@angular/forms';
import { BasketSimpleViewComponent } from './components/basket-simple-view/basket-simple-view.component';
import { OrderInfoListComponent } from './components/order-info-list/order-info-list.component';
import { CurrentBasketViewComponent } from './components/current-basket-view/current-basket-view.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BasketService } from './services/basket.service';
import { InlineSVGModule } from 'ng-inline-svg';
import { NoProductDialogComponent } from './components/no-product-dialog/no-product-dialog.component';
import { MaterialModule } from 'src/app/material.module';

const orderServiceClass = environment.production ? OrderOdooService : OrderInMemoryService;
const productsServiceClass = environment.production ? ProductsOdooService : ProductsInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    RouterModule,
    GeneralModule,
    FontAwesomeModule,
    InlineSVGModule,
    MaterialModule,
  ],
  exports: [
    BasketViewComponent,
    BasketSimpleViewComponent,
    OrderInfoListComponent,
    CurrentBasketViewComponent,
    NoProductDialogComponent,
  ],
  declarations: [
    BasketViewComponent,
    BasketSimpleViewComponent,
    OrderInfoListComponent,
    CurrentBasketViewComponent,
    NoProductDialogComponent,
  ],
  providers: [
    OrderStateService,
    ProductsStateService,
    [{ provide: OrderService, useClass: orderServiceClass }],
    [{ provide: ProductsService, useClass: productsServiceClass }],
    BasketService,
  ],
  entryComponents: [
    NoProductDialogComponent,
  ]
})
export class OrderModule { }
